/* Copyright (c) 2020-present CloudIO Inc */

import { DBRow, IoHowTos } from '@cloudio-saas/datasource-types';
import { useStateXAtomSetter } from '@cloudio-saas/statex';
import { Box, Typography } from '@mui/material';
import useWindowSize from 'hooks/useWindowSize';
import Icon from 'icons/Icon';
import { usePlatform } from 'platform/PlatformHooks';
import { followOnHowToAtom } from './HowToState';
import StepContainer from './StepContainer';

export function NavigationStep({
  howTo: { initUri = '#/', howToUid, appUid },
}: {
  howTo: DBRow<IoHowTos>;
}) {
  const displayUri = initUri.indexOf('?') > 0 ? initUri.split('?')[0] : initUri;
  const set = useStateXAtomSetter(followOnHowToAtom);
  const platform = usePlatform();
  const [width] = useWindowSize();
  const md = width > 1200;
  return (
    <StepContainer
      index={1}
      title={
        <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          <Typography whiteSpace="nowrap" variant="h6" flexShrink={0}>
            Navigate to {md ? '' : initUri}
          </Typography>
          {md ? (
            <Box
              component={'a'}
              sx={{
                borderColor: 'rgb(191 219 254)',
                bgcolor: 'rgb(239 246 255)',
                border: '1px solid',
                borderRadius: '0.25rem',
                color: 'rgb(29 78 216)',
                padding: '3px 8px',
                ml: 1,
                overflow: 'hidden',
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                cursor: 'pointer',
              }}
              href={initUri}
              target="_blank"
            >
              <Box
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flex: 1,
                }}
              >
                {displayUri}
              </Box>
              <Icon iconName="external-link" color="primary" />
            </Box>
          ) : null}
          {md ? (
            <Box
              sx={{
                borderColor: 'rgb(191 219 254)',
                bgcolor: 'rgb(239 246 255)',
                border: '1px solid',
                color: 'rgb(29 78 216)',
                borderRadius: '0.25rem',
                padding: '0px 8px',
                ml: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                cursor: 'pointer',
                textDecoration: 'none',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                set({ appUid, howToUid });
                platform.navigateTo(initUri);
              }}
            >
              Follow On <Icon iconName="sidebar-flip" color="primary" />
            </Box>
          ) : null}
        </Box>
      }
    />
  );
}
